import {React,useEffect,useState }from "react"
import PropTypes from 'prop-types';
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "../../components/Common/ChartsDynamicColor";

const StackedColumnChart = ({ dataColors, periodData }) => {
    const [agent, setAgent] = useState('')
    const [agentCode, setAgentcode] = useState('')
    const [ct, setCt] = useState([])
        const [credentials, setCredentials] = useState(null)
        const [isAuth, setIsauth] = useState(false)
        const company = 'Definite'
      
        useEffect(()=>{
        const getCredentials =async()=>{
          const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
          const data = await res.json();
          const {Username, Password} = data;
          const cred = btoa(`${Username}:${Password}`)
          setCredentials(btoa(`${Username}:${Password}`))
          setIsauth(true)
      
      
        }
        getCredentials()
      
        },[])

  
    useEffect(() => {
  
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
    
        }
        }, []);
    
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                  method:"GET",
                        headers:{
                          'Authorization': `Basic ${credentials}`,
                          'Content-Type': "application/json"
                        }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
    
            }

            if(agent && isAuth){
           
                getAgentcode()
            }
        },[agent,isAuth])

        const [chartData, setChartData] = useState({
          series: [
            { name: 'New Business', data: [] },
            { name: 'Extension', data: [] }
          ],
          options: {
            chart: {
              type: 'bar',
              stacked: true,
              toolbar: { show: true }
            },
            plotOptions: {
              bar: { horizontal: false }
            },
            xaxis: { categories: [] },
            yaxis: { title: { text: 'Production Per Month' } },
            colors: ['#0f4f48', '#eb2229'],
            legend: { position: 'top' },
            fill: { opacity: 1 }
          }
        });
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
      
        useEffect(() => {
          const fetchMonthlySummary = async() => {
            try {
              setLoading(true);
              setError(null);
              
              const response = await fetch(`https://digitalapi.definiteassurance.com/api/monthly-summary?agent=${agentCode}`,{
                  method:"GET",
                    headers:{
                      'Authorization': `Basic ${credentials}`,
                      'Content-Type': "application/json"
                    }
              });
              
              // if (!response.data.success) {
              //   console.log(chartData)
              //   throw new Error(response.data.message || 'Failed to fetch data');
              // }
      
              const dt = await response.json();
              const {data} = dt;

            
              
              
              setChartData(prev => ({
                ...prev,
                series: [
                  { name: 'New Business', data: data.map(item => item.newBusiness || 0) },
                  { name: 'Extension', data: data.map(item => item.extension || 0) }
                ],
                options: {
                  ...prev.options,
                  xaxis: {
                    categories: data.map(item => item.month || ''),
                    labels: { trim: true }
                  }
                }
              }));
            } catch (err) {
              console.error('Error:', err);
              setError(err.message || 'Failed to load chart data');
            } finally {
              setLoading(false);
            }
          };

          if(agentCode && isAuth){
            fetchMonthlySummary()
          }
          
          
        }, [agentCode,isAuth]);
      
        if (loading) return <div className="text-center py-4">Loading chart data...</div>;
        if (error) return <div className="alert alert-danger">{error}</div>;


        
  
  return (
    <div>
      

      <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
            className="apex-charts"
          />
    </div>
  );
}

StackedColumnChart.propTypes = {
  periodData: PropTypes.any
}
export default StackedColumnChart;
